import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: "bit",
    style: _normalizeStyle(`grid-area: ${_ctx.y+1}/${_ctx.x+1}/${_ctx.yEnd+1}/${_ctx.xEnd+1}; opacity: ${ _ctx.isCandidate ? '0' : '1' }`)
  }, null, 4 /* STYLE */))
}